import React, { useState, useEffect } from "react";
import "./shiftBox.scss";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";

import CustomDialog from "../../../../components/customDialog/CustomDialog";

import {
  removeUserSubscritpionWS,
  subscriptionShiftWS,
} from "../../../../components/shiftInfoBox/api/shiftInfoBoxApi";

import { Button, Stack } from "react-bootstrap";
import { t } from "i18next";
import { formatDateRange } from "../../../../utils/formatDateRange";
import moment from "moment";
import { gestioneSnackbar } from "../../../../utils/common";

const ShiftBox = ({
  id,
  title,
  address,
  description,
  startDatetime,
  endDatetime,
  qtaAvailable,
  isAdmin,
  eventFinished,
  alreadySubscribed,
  linkMoreDetails,
}) => {
  const [alreadySubscribedState, setAlreadySubscribedState] = useState(false);

  useEffect(() => {
    setAlreadySubscribedState(alreadySubscribed);
  }, []);

  const handleClickSubscribed = (id_shift) => {
    //Se la data di fine è già stata superata allora non posso iscrivermi o disiscrivermi
    const now = moment();
    if (moment(endDatetime, "DD/MM/YYYY HH:mm").isBefore(now))
      return gestioneSnackbar(
        true,
        t("event.shift_already_terminated"),
        "error"
      );

    if (alreadySubscribedState) {
      //Sono già iscritto e confermato quindi posso disiscrivermi
      removeUserSubscritpionWS({ id_shift })
        .then((res) => {
          gestioneSnackbar(true, res.message, "success");
          setAlreadySubscribedState(false);
        })
        .catch((err) => {
          gestioneSnackbar(true, err.message, "error");
        });
    } else {
      //Evento già terminato
      if (eventFinished)
        return gestioneSnackbar(
          true,
          t("event.subscription_to_terminated_event"),
          "error"
        );

      // Posti finiti
      if (!qtaAvailable)
        return gestioneSnackbar(
          true,
          t("event.subscription_not_available_spots"),
          "error"
        );

      subscriptionShiftWS({ id_shift })
        .then((res) => {
          gestioneSnackbar(true, res.message, "success");
        })
        .catch((err) => {
          gestioneSnackbar(true, err.message, "error");
        });
    }
  };

  return (
    <Stack className="shift-box-container-info" gap={2}>
      {/**Titolo e se sono admin dettagli */}
      <Stack
        direction="horizontal"
        className="d-flex justify-content-between w-100"
        gap={2}
      >
        <span className="title-of-shift">{title?.toUpperCase()}</span>
        {isAdmin ? (
          <Button
            size="sm"
            variant="info"
            style={{ borderRadius: 10 }}
            href={linkMoreDetails}
            className="d-flex justify-content-center"
          >
            <Stack
              direction="horizontal"
              gap={0}
              className="d-flex justify-content-center align-items-center"
            >
              <span>{t("common.more_details")}</span>
              <KeyboardArrowRightIcon />
            </Stack>
          </Button>
        ) : null}
      </Stack>

      <Stack gap={1} className="wrapper-address-date">
        {/**Indirizzo dell'evento */}
        <div className="address-of-shift">{address}</div>
        {/**Range della data e dell'ora */}
        <div className="start-end-time-range-shift">
          {formatDateRange(
            startDatetime,
            endDatetime,
            "DD/MM/YYYY HH:mm",
            "DD/MM/YYYY HH:mm",
            true
          )}
        </div>
      </Stack>

      {/**Descrizione del turno se non sono un amministratore */}
      {description ? (
        <Stack className="wrapper-description">
          <hr />
          <p className="description-of-shift">{description}</p>
        </Stack>
      ) : null}

      <Stack className="d-flex align-items-end" gap={0}>
        {alreadySubscribedState ? (
          /**Modale di conferma per la disiscrizione */
          <CustomDialog
            title={t("event.title_modal_unsubscribed_shift")}
            body={t("event.body_modal_unsubcribed_shift")}
            callback={() => {
              handleClickSubscribed(id);
            }}
            trigger={
              <Button variant="info" size="sm" style={{ borderRadius: 10 }}>
                <Stack
                  direction="horizontal"
                  gap={1}
                  className="d-flex justify-content-center align-items-center"
                >
                  <span>{t("common.already_subscribed")}</span>
                  <DoneAllOutlinedIcon />
                </Stack>
              </Button>
            }
          />
        ) : (
          /**Bottone per iscriverti */
          <Button
            style={{ borderRadius: 10 }}
            size="sm"
            variant="success"
            onClick={(e) => {
              e.stopPropagation();
              handleClickSubscribed(id);
            }}
          >
            <Stack direction="horizontal">
              <Stack
                direction="horizontal"
                gap={1}
                className="d-flex justify-content-center align-items-center"
              >
                <span>{t("event.sign_up_for_the_shift")}</span>
                <GroupAddOutlinedIcon />
              </Stack>
            </Stack>
          </Button>
        )}
        <span className="qta-available-shift">
          {t("event.n_available_volunteers", { number: qtaAvailable })}
        </span>
      </Stack>
    </Stack>
  );
};

export default ShiftBox;
